export default __webpack_public_path__ + "static/media/ROM CLASS-8_SYLLABUS_2025-26.f66f1343.pdf";